/**
 * Tayro brand mark — "Switchback" (E1 rebrand, HANDOFF @ d218c8d4637a).
 * Canonical geometry; colors are locked tokens. The ≤20px small cut keeps
 * the mark legible at favicon scale.
 */
type TayroMarkProps = {
  /** Rendered size in px; ≤20 switches to the small optical cut. */
  size?: number;
  /** Accessible name. Omit for decorative use (renders aria-hidden). */
  title?: string;
};

export function TayroMark({ size = 32, title }: TayroMarkProps): JSX.Element {
  const small = size <= 20;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <rect width="64" height="64" rx="16" fill="var(--signal)" />
      <path
        d="M15 46 L27 26 L35 34 L46 20"
        fill="none"
        stroke="var(--paper)"
        strokeWidth={small ? 9 : 6.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="50.5" cy="14.5" r={small ? 5.5 : 4} fill="var(--today)" />
    </svg>
  );
}
